import randomGenerator from '../modules/random-generator';
import passwordVisibility from '../modules/password-visibility';
import escape from 'lodash.escape';

const initialize = () => {
    randomGenerator();
    passwordVisibility();

    let contactDeleteModal = document.getElementById('contactDeleteModal');
    console.log(contactDeleteModal);
    if (!contactDeleteModal) {
        return;
    }

    contactDeleteModal.addEventListener('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let contact = button.data('contact');
        let action = button.data('action');

        contactDeleteModal.querySelector('#contactDeleteForm').setAttribute('action', action);
        contactDeleteModal.querySelector('#contactTypeNameSpan').innerHTML = escape(contact);
    });
};

export default initialize;
